export const getArticles = () => async (dispatch) => {
  
  // try {
  //   const response = await fetch(
  //     "https://raw.githubusercontent.com/charlenry/jsonfiles/main/blog-app/posts_fr.json"
  //   );

  //   const data = await response.json();

  //   dispatch({
  //     type: "LOAD_ARTICLES",
  //     payload: data.posts,
  //   });
  // } catch (error) {
  //   dispatch({
  //     type: "GET_ARTICLES_FAILED",
  //   });
  // }

  import("../data/posts_fr.js").then((action) => {
    dispatch({
      type: "LOAD_ARTICLES",
      payload: action.posts,
    });
  });
  
};

export const setButtonSendClicked = () => async (dispatch) => {
  dispatch({
    type: "BUTTON_SEND_CLICKED",
  });
};

export const addArticle = (article) => async (dispatch) => {
  dispatch({
    type: "ADD_ARTICLE",
    payload: article,
  });
};
